import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Container,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CircularProgress,
  useTheme,
} from "@mui/material";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";

const API_URL = process.env.REACT_APP_API_URL;

const EnterpriseAIAdmin = () => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/enterprise-ai-admin/`)
      .then((res) => {
        console.log("API Response:", res.data); // Debug
        const response = res.data;
        if (Array.isArray(response)) setData(response);
        else if (Array.isArray(response.data)) setData(response.data);
        else if (Array.isArray(response.results)) setData(response.results);
        else setData([]);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setData([]);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <Header1 />
      <Container maxWidth="xl" sx={{ py: 6 }}>
        <Typography
          variant="h4"
          fontWeight={700}
          mb={4}
          color={theme.palette.text.primary}
        >
          Enterprise AI Leads
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Paper
            sx={{
              borderRadius: 3,
              overflowX: "auto",
              boxShadow: theme.shadows[3],
              bgcolor: theme.palette.background.paper,
            }}
          >
            <Table>
              <TableHead
                sx={{
                  bgcolor:
                    theme.palette.mode === "dark"
                      ? theme.palette.grey[900]
                      : "#f8fafc",
                }}
              >
                <TableRow>
                  {[
                    "Name",
                    "Email",
                    "Contact",
                    "Interested",
                    "Query",
                    "Created At",
                  ].map((head) => (
                    <TableCell
                      key={head}
                      sx={{
                        color: theme.palette.text.primary,
                        fontWeight: "bold",
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((row) => (
                    <TableRow
                      key={row.enterprise_id || row.id}
                      hover
                      sx={{
                        "&:hover": {
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? theme.palette.grey[800]
                              : theme.palette.grey[100],
                        },
                      }}
                    >
                      <TableCell sx={{ color: theme.palette.text.primary }}>
                        {row.name || "-"} {row.surname || ""}
                      </TableCell>
                      <TableCell sx={{ color: theme.palette.text.primary }}>
                        {row.email || "-"}
                      </TableCell>
                      <TableCell sx={{ color: theme.palette.text.primary }}>
                        {row.contact || "-"}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={row.interested ? "Yes" : "No"}
                          color={row.interested ? "success" : "default"}
                          size="small"
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          maxWidth: 300,
                          whiteSpace: "pre-wrap",
                          color: theme.palette.text.primary,
                        }}
                      >
                        {row.query || "-"}
                      </TableCell>
                      <TableCell sx={{ color: theme.palette.text.primary }}>
                        {row.created_at
                          ? new Date(row.created_at).toLocaleString()
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      align="center"
                      sx={{ color: theme.palette.text.secondary }}
                    >
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        )}
      </Container>
      <Footer2 />
    </div>
  );
};

export default EnterpriseAIAdmin;
